import * as React from 'react';

import { BuilderField as BuilderComponent } from '../../../../../../components/Field/newBuildingFlatSale/BuilderField';
import { getBuilderFromOffer } from '../../../../../../utils/builder';
import { BuilderStatsFieldContainer } from './BuilderStatsFieldContainer';
import { EmptyField } from '../../../../../../components/Field/common';
import { useOfferContext } from '../../../../../../utils/offerContext';

export const BuilderFieldContainer: React.VFC = () => {
  const offer = useOfferContext();
  const builder = getBuilderFromOffer(offer);

  if (builder == null) {
    return <EmptyField />;
  }

  return (
    <BuilderComponent
      imageUrl={builder.logoUrl || ''}
      name={builder.name}
      url={builder.profileUrl}
      stats={<BuilderStatsFieldContainer />}
    />
  );
};
